import { resolveAppOrigin } from '../../config/appOrigin';

/**
 * Resolve NG Meet's OWN origin — the origin the bundle was served from.
 *
 * In hosted/MF mode this is the standalone NG Meet origin (e.g.
 * `http://localhost:8081` in dev, or the deployed remote host in prod), which
 * is exactly where we want the meeting popup to load from so it gets our
 * `index.html` (and its Jitsi `external_api.js`). Falls back to the current
 * window origin when the bundle origin is unavailable (standalone build /
 * tests).
 *
 * SM-1243: thin alias over the shared resolver in `config/appOrigin`.
 */
export const resolveMeetOrigin = (): string => resolveAppOrigin() ?? window.location.origin;
